import {DataTableBulkSelectorConfig, RecordedEntryDataTableBulkSelector} from "@/shared/ui/dataTableBulkSelector";
import {ReportWorkingTime, WorkingTimeTableSums} from "@/shared/timr";

export class WorkingTimeBulkSelector extends RecordedEntryDataTableBulkSelector<ReportWorkingTime> {

	constructor(public config: DataTableBulkSelectorConfig) {
		super(config);
	}

	protected initAllSelectedSum(dataTableJsonData: { workingTimeSums?: WorkingTimeTableSums }) {
		if (dataTableJsonData.workingTimeSums) {
			const workingtimeSums = dataTableJsonData.workingTimeSums;
			this.allSelectedDurationNetSum = workingtimeSums.duration;
			this.allSelectedDurationGrossSum = workingtimeSums.durationGross;
			this.allSelectedBreakTimeSum = workingtimeSums.breakTime * 60000;
		}
	}
}
